import { createApiCallActions } from 'src/app/common/store/generic.actions';
import { Job } from './types';

export const jobActions = {
  getById: createApiCallActions<Job>('job', 'getById'),
  postJob: createApiCallActions<Job>('job', 'postJob'),
  updateJob: createApiCallActions<Job>('job', 'updateJob'),
};

export type JobAction = typeof jobActions;
